import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import SubNav from "../../../shared/subnav/SubNav";
import PendingActions from "../pendingActions/PendingActions";
import HasPermissionTo from "../../../common/HasPermissionTo";
import ReservationRelease from "./reservationRelease/ReservationRelease";
import Announcement from "../annoucements/Announcement";
import NscOrderAcceptanceNotifications from "../nscNotifications/NscOrderAcceptanceNotifications";

class NscDashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 0,
    };
    this.showMarketDropDown =
      this.props.user.permissions.rolePermissions.hasOwnProperty(
        "orderSearchMarketDropDown:view"
      );
  }

  onMarketChange = (event) => {
    event.preventDefault();
    const market = event.target.value;
    this.props.updateCurrentMarket(market);
  };

  handleTabChange = (event, selectedTab) => {
    this.setState({ selectedTab });
  };

  getTabs() {
    return [
      {
        menuName: this.props.t("ProgressBar.notifications"),
        enabled: true,
        id: "notifications",
        hide: !this.props.user.permissions.rolePermissions.hasOwnProperty(
          "pendingActionQueue:view"
        ),
      },
      {
        menuName: this.props.t("ProgressBar.release"),
        enabled: true,
        id: "release",
        hide:
          true ||
          !this.props.user.permissions.rolePermissions.hasOwnProperty(
            "reservationReleaseTab"
          ),
      },
    ];
  }

  render() {
    return (
      <section className="pageWrapper">
        <SubNav
          dashboard={true}
          showCustomMarketDropdown={this.showMarketDropDown}
          selectedTab={this.state.selectedTab}
          title={this.props.t("GlobalNavBar.dashboard")}
          action={this.handleTabChange}
          tabs={this.getTabs()}
          listOfMarkets={this.props.groups}
          updateMarket={this.onMarketChange}
          value={this.props.selectedMarket}
          {...this.props}
        />

        {this.state.selectedTab === 0 ? (
          <>
            <HasPermissionTo
              perform={["pendingActionQueue:view"]}
              permissions={this.props.user.permissions.rolePermissions}
              render={() => <PendingActions {...this.props} />}
            />
            <HasPermissionTo
              perform={["nscAnnouncement:view"]}
              permissions={this.props.user.permissions.rolePermissions}
              render={() => <Announcement {...this.props} />}
            />
            <NscOrderAcceptanceNotifications {...this.props} />
          </>
        ) : (
          this.state.selectedTab === 1 && (
            <HasPermissionTo
              perform={["reservationReleaseTab"]}
              permissions={this.props.user.permissions.rolePermissions}
              render={() => <ReservationRelease {...this.props} />}
            />
          )
        )}
      </section>
    );
  }
}

export default withTranslation("emp")(NscDashboard);
